<template>
    <div id="gist" style="margin-left:0px;margin-right:0px;">
      <b-modal  content-class="modal-st" size="lg" id="chart-message" centered="true" hide-footer>
        <template v-slot:modal-title>
          Share the chart
        </template>
        <div class="d-block text-center scrollbar" id="style-4" style="max-height:100vh;overflow-y:auto;">
          <div class="form-group" style="text-align:left;margin-top: 0.5vw;">
            <div class="form-group">
                  <label  class="control-label card-form-label" for="exampleFormControlInput1">Type Message here</label>
                  <md-field style="margin-bottom:2px;">
                    <md-input type="text" id="fortext" class="form-control"  placeholder="" v-model="chatmessage" name="chatmessage"></md-input>
                  </md-field>
            </div>
            <div class="form-group" style="margin-top:20px;" >
                <label  class="control-label card-form-label" for="exampleFormControlInput1">Add Users To Discussion</label>
                <multiselect :max-height="300" v-model="selected_users" :options="allusers" :multiple="true" :taggable="false" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select" label="Email" track-by="Email">
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                </multiselect>   
            </div>
            <div style="margin-top:70px;">
              <button class="btn cncel_btn" @click="closemessagemodal()">Cancel</button>
              <button class="btn update_btn" @click="sendToChat(s_id, chatmessage)">Share</button>
            </div>
          </div>
        </div>
      </b-modal>
     
      <div class="row  Rounded-Rectangle-white-square" v-show="!plotloading && tabs.length <= 0" style="margin:0px;height:100vh;">
        <div class="col-md-12">
          <div class="row" style="margin-top:2vh">
		        	<div class="col-md-1"></div>
		        	<!--<div class="col-md-11">
				    	<p class="empty_set_dev_content"><img class="empty_set_img" src="../assets/icon-deviation.png">Deviations<span class="empty_set_deviation">(6)</span><span class="empty_set_dist">|</span><img class="empty_set_img" src="../assets/icon-discussion.png">Discussions<span class="empty_set_deviation">(21)</span><span class="empty_set_dist">|</span><img class="empty_set_img" src="../assets/icon-notification.png">Notifications<span class="empty_set_deviation">(11)</span></p>
				    </div>-->
				</div>
				<div class="row">
			      <div class="col-md-12">
						  <div class="dashboard-word" style="margin:2vh;">Dashboard</div>
						</div>
						<div class="col-md-12">
				        <md-card class="card_d">
				        	<md-card-content>
					        <div class="row">
					        	<p class="dashboard_header tab-title">Your dashboard will appear here.</p>
					        </div>
					          <div class="row">
					        	<div class="col-md-4">
					        		<md-card class="card-white">
					        			<md-card-content>
					        				<div class="row">
					        					<div class="col-md-4">
					        					  <h2 class="empty_set_dashboard_no">0</h2>	
					        					</div>
					        					<div class="col-md-8">
					        					  <div class="Rectangle-547"></div>
					        					  <div class="Rectangle-547"></div>
					        					  <div class="Rectangle-549"></div>
					        					</div>
					        				</div>	        				
					        			</md-card-content>
					        		</md-card>
					        	</div>
					        	<div class="col-md-4">
					        		<md-card class="card-white">
					        			<md-card-content>
					        				<div class="row">
					        					<div class="col-md-4">
					        						<div class="row Path-417">
						        					  <img src="../assets/gar.png">
						        					</div>	
					        					</div>
					        					<div class="col-md-8">
					        					  <div class="Rectangle-547"></div>
					        					  <div class="Rectangle-547"></div>
					        					  <div class="Rectangle-549"></div>
					        					</div>
					        				</div>	        				
					        			</md-card-content>
					        		</md-card>
					        	</div>
					        	<div class="col-md-4">
					        		<md-card class="card-white">
					        			<md-card-content>
					        				<div class="row">
					        					<div class="col-md-4">
					        					  <h2 class="empty_set_dashboard_no">0</h2>	
					        					</div>
					        					<div class="col-md-8">
					        					  <div class="Rectangle-547"></div>
					        					  <div class="Rectangle-547"></div>
					        					  <div class="Rectangle-549"></div>
					        					</div>
					        				</div>	        				
					        			</md-card-content>
					        		</md-card>
					        	</div>
					        </div>
					    	</md-card-content>
						</md-card>
					</div>
			</div>
        </div>
      </div>
      <div class="row Rounded-Rectangle-white-square" v-show="plotloading" style="margin:0px;height:100vh">
        <div class="col-md-12" style="text-align:center;margin-top:20vh;">
        <span slot="spinner"><b-spinner style="width: 4rem; height: 4rem;color: #346168!important;" variant="primary" label="Text Centered"></b-spinner>
            </span>
        </div>
      </div>
      <div class="row scrollbar style-4" id="style-4" v-show="!plotloading && tabs.length > 0" style="margin:0px;min-height:90vh;max-height:100vh;overflow:auto">
        <div class="col-md-12" style="padding-left:0px;padding-right: 5px;">
          <div class="chat Rounded-Rectangle-white-square"  style="padding:20px;margin-bottom:20vh;">
            <div class="row">
              <!--<div class="col-md-10">
                <p style="text-align: left;"><img src="../assets/icon-deviation.png" style="margin-right: 1vh">Deviations<span style="margin-left: 1vh;color:#f16722">(6)</span><span style="margin-left:4vh;margin-right:4vh">|</span><img src="../assets/icon-discussion.png" style="margin-right: 1vh">Discussions<span style="margin-left: 1vh;color:#f16722">(21)</span><span style="margin-left:4vh;margin-right:4vh">|</span><img src="../assets/icon-notification.png" style="margin-right: 1vh">Notifications<span style="margin-left: 1vh;color:#f16722">(11)</span></p>
              </div>-->
              <div class="col-md-11" style="text-align:left;padding:2vh;">
                <a v-for="tab in tabs"  @click="view(tab)"><b-badge v-bind:class="['kim', { 'topbox1' : show == tab},{'topbox' : show != tab}]">{{tab}}</b-badge></a>
              </div>
              <div id= "scroll-to" class="col-md-12" v-show="singlePlotShow" style="margin-bottom:2vh">
                <div class="card card-white" id="single-plot" style="padding:4vh 3vh">
                  <div class="row">
                    <div class="col-md-12" style="margin-bottom:10px;">
                      <h6 style="text-align:left;text-transform: capitalize;color: #474747;line-height: 0.8;">{{singleplotdata.name}}
                        <span style="float:right"><a @click="closeFullScreen()"><span class="material-icons" style="color:#4c767c">close</span></a></span>
                      </h6>
                    </div>
                    <div style="min-height:70vh" class="col-md-12" id="signleP">
                      <span v-html="singleplotdata.pdiv"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" v-show="!singlePlotShow">
                <div class="card card_d" v-show="show != '1' && singleloading" style="padding:2vh 1vh 2vh 1vh">
                  <!--<div class="tab-title">{{show}}</div>-->
                  <div class="row" style="margin-left:1vh;margin-right:1vh">
                    <div class="col-md-12" v-show="singleloading" style="text-align:center;margin-top:2vh;">
                        <span slot="spinner"><b-spinner style="width: 4rem; height: 4rem;margin-top:5vh;margin-bottom:25vh;color: #346168!important;" variant="primary" label="Text Centered"></b-spinner>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-show="!singleloading">
                  <div class="card card_d" v-show="show != '1' && plots.length > 0" style="padding:2vh 2vh 2vh 2vh">
                    <div class="row" style="margin:0px;">
                      <div class="col-md-12" style="padding:1vh;" v-if="apitoken == '5930771' && show == 'Macros'">
                        <div class="card card-white">
                          <div class="card-body" style="text-align:center;min-height:5vh;min-width:100%">
                            <div class="row">
                              <div class="col-md-12" style="padding-right:0px">
                                <h6 style="text-align:left;text-transform: capitalize;color: #474747;line-height: 0.8;">Process Flow
                                </h6>
                                <div class="plot-time">Updated on 2021.12.04</div>
                              </div>
                            </div>
                            <div class="row" style="margin-top:10px;">
                              <div style="min-height:100vh" class="col-md-12">
                                <iframe style="height:100%;width:100%;" src="https://web.wynum.in/templates/flowplot"></iframe>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4" :id="plot.Div_id" v-for="(plot, index) in plots" v-show="plot.Tag == show && plots.length > 0" v-bind:class="{'col-md-6' : plot.Width == 'MD','col-md-12' : plot.Width =='LG'}" style="padding:1vh;">
                        <div class="card card-white">
                          <div class="card-body" style="text-align:center;min-height:5vh;min-width:100%">
                            <div class="row">
                              <div class="col-md-12" style="padding-right:0px">
                                <h6 style="text-align:left;text-transform: capitalize;color: #474747;line-height: 0.8;">{{plot.name}}
                                  <span style="float:right"><a @click="showmodal(plot.ID)"><span class="material-icons" style="color:#4c767c">more_vert</span></a></span>
                                  <span style="float:right"><a @click="fullscreen(plot)"><span class="material-icons" style="color:#4c767c">fullscreen</span></a></span>
                                </h6>
                                <div class="plot-time">Updated on {{plot.Updated_on  | dateFormat('YYYY.MM.DD')}}</div>
                              </div>
                            </div>
                            <div class="row">
                              <div style="min-height:70vh" class="col-md-12" :id="plot.Plot_div">
                                <span  :id="plot.ID" v-html="plot.div"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card card_d" v-show="plots.length <= 0 && !singleloading">
                    <div class="row" style="text-align:center">
                      <div class="col-md-12" style="padding: 20px;font-size: 20px;">
                        No Data.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>



<script>
import axios from 'axios';
import Vue from 'vue'
import postscribe from 'postscribe'
import { EventBus } from '../event-bus.js'
import Multiselect from 'vue-multiselect'

export default {
    name : "Plot",
    data(){
        return {
            allscripts : "",
            tabs : [],
            plots : [],
            show : "1",
            plotloading : true,
            chatmessage : "",
            s_id : "",
            singleloading: false,
            scripts : "",
            user : {},
            allusers : [],
            selected_users : [],
            singlePlotShow : false,
            singleplotdata : {},
        }
    },
    props : ['apitoken'],
    components: {Multiselect},
    created(){
      this.plotloading = true
    },
    mounted(){
      this.plots = []
      this.tabs = []
      let alltabs = []

      axios.get('/getprofile').then(res => {
          if (res.data.value !== 1) {
            this.user = res.data
            this.getTabs()
            this.getUsers(res.data)
          }
      })
    },
    methods : {
      getUsers(userdata){
            axios.get('/clientProjectUser?apitoken='+this.apitoken, {
            }).then(res => {
                this.user_loading = false
                if(res.data && res.data.value != 1){
                    for (let i = 0; i < res.data.length; i++) {
                        const element = res.data[i];
                        if(element.Email != userdata.Email){
                            this.allusers.push(element)
                        }
                    }
                    //All Users Option
                    var k = {}
                    k.Email = "All Users"
                    this.allusers.unshift(k)
                }else{
                    this.user_loading = false
                    this.ShowToast("Error", 'Error while loading Data. Please try later', "default")
                }
            }).catch((error) => {
                this.user_loading = false
                this.ShowToast("Error", 'Error while loading Data. Please try later', "default")
            })
      },
      getTabs(){
        axios.get('/dashboardTabs?apitoken='+this.apitoken)
          .then(res => {
            this.plotloading = false
            if(res.data != null && res.data.value != 1){
              let tabdata = res.data
              if(tabdata.length > 0) {
                for (let i = 0; i < tabdata.length; i++) {
                  const element = tabdata[i];
                  if (element == 'Dashboard' || element == 'dashboard' || element.toUpperCase().includes("DASHBOARD")){
                    this.tabs.push(element)
                    tabdata.splice(i, 1)
                    break
                  }
                }
              }
              tabdata = tabdata.sort()
              this.tabs = this.tabs.concat(tabdata)
              if(this.tabs.length > 0){
                this.show = this.tabs[0]
                this.loadplots(this.show)
              }
            }
          })
      },
      view(tag){
        this.show = tag
        this.loadplots(this.show)
        this.closeFullScreen()
      },
      loadplots(tag){
        let scripts = `<script type="text/javascript">
        setTimeout(function(){
        ` 
        this.singleloading = true
        this.plots = []
            axios.get('/dashboard?apitoken='+this.apitoken+"&tag="+tag)
              .then(res => {
                if(res.data != null && res.data.value != 1){
                  this.singleloading = false
                  let unorderedPlots = []
                  for (let i = 0; i < res.data.length; i++){
                    if(res.data[i].Div != null){
                      var checkUaccess = this.checkUserAccess(res.data[i].Users)
                      if (checkUaccess){
                        var a = {}
                        a.name = res.data[i].Name
                        res.data[i].Div = res.data[i].Div.replace(/\\"/g, '"')
                        res.data[i].Div = res.data[i].Div.replace(/\\'/g, "'")
                        res.data[i].Div = res.data[i].Div.replace(/\r?\n|\r/g, "\n")
                        a.div_fake = res.data[i].Div
                        a.Tag = res.data[i].Tags
                        a.ID = res.data[i]._id
                        a.Div_id = "Div_" + res.data[i]._id
                        a.Plot_div = "Plot_div_" + res.data[i]._id
                        a.Updated_on = new Date(res.data[i].Updated_on)
                        a.Position = res.data[i].Position
                        if(res.data[i].Size != "" && res.data[i].Size != undefined && res.data[i].Size != null){
                          var array = res.data[i].Size.split(",")
                          if(array.length > 0){
                            a.Height = array[0]
                            a.Width = array[1]
                          }
                        }else{
                          a.Height = "LG"
                          a.Width = "MD"
                        }
                      
                        if(res.data[i].Script != null){
                          res.data[i].Script = res.data[i].Script.replace(/\\"/g, '"')
                          res.data[i].Script = res.data[i].Script.replace(/\\'/g, "'")
                          res.data[i].Script = res.data[i].Script.replace(/\r?\n|\r/g, "\n")
                          var str = res.data[i].Script.replace('<script type="text/javascript">', "\n")
                          var str1 = str.replace("<\/script>", "\n")
                          scripts += str1
                          a.Script = str1
                          
                          str1 = str1.replace(/"plot_height":400,"plot_width":400,/g, '')
                          str1 = str1.replace(/"plot_height":100,"plot_width":100,/g, '')

                          str1 = str1.replace(/plot_height&quot;:400,&quot;plot_width&quot;:400,/g, '')
                          str1 = str1.replace(/plot_height&quot;:100,&quot;plot_width&quot;:100,/g, '')
                          str1 = str1.replace(/scale_both/g, 'stretch_both')
                        }
                        unorderedPlots.push(a)
                      }
                    }
                  }

                  scripts = scripts + `}, 500);
        <\/script>`

                  this.plots = this.sortByKey(unorderedPlots, 'Position')

                  this.loader()
                  
                  let newthis = this
                  setTimeout(function(){ 
                    for (let j = 0; j < newthis.plots.length; j++) {
                      let ele = newthis.plots[j]
                      if(document.getElementById(ele.Plot_div) != null){ 
                        var height;
                        height = ele.Actual_height
                        newthis.plots[j].div = newthis.plots[j].div_fake.replace(/<div class="plotly-graph-div" /g, '<div class="plotly-graph-div" style="height:'+height+'px"; ')
                      }else{
                        newthis.plots[j].div = newthis.plots[j].div_fake.replace(/<div class="bk-root" /g, '<div class="bk-root" style="width:100%;height:100%"; ')
                      }
                    }
                    newthis.$forceUpdate()
                  }, 500);
                  
                //  scripts = scripts.replace(/\\/g, '')
                  // / scripts = scripts.replace(/\//g, '')
                  //scripts = cleanString(scripts)
//console.log(scripts)
                  setTimeout(() => {
                    postscribe('#gist', scripts)
                  }, 500);
                }else{
                  this.singleloading = false
                } 
        })
      },
      checkUserAccess(users_str){
        if(users_str == "" || users_str == undefined || users_str == null){
          return true
        }else{
          let array = users_str.split(",")
          if (array.length > 0){
            for (let i = 0; i < array.length; i++) {
              const element = array[i];
              if(element.trim().toUpperCase() == this.user.Email.toUpperCase()){
                return true
              }
            }
          } 
        }
        return false
      },
      loader(){
        for (let j = 0; j < this.plots.length; j++) {
          var newthis = this
          setTimeout(function(){ 
            newthis.addloadingIconToPlots(newthis.plots[j].ID, newthis.plots[j].Height, newthis.plots[j].Plot_div, j)
          }, 50);
        }
      },
      setHeight(id, height){
        var div_id = id
        var div_height = height
        var el = document.getElementById(div_id) 
        setTimeout(() => {
          el.style.removeProperty('min-height');
          el.style.minHeight = div_height + " px !important"
        }, 500);
      },
      addloadingIconToPlots(Plot_id, height, plot_div, index){
          if(document.getElementById(plot_div) != null){ 
            var height;
            var el = document.getElementById(plot_div)
            if(height == "SM"){
              height = document.getElementById(plot_div).offsetHeight / 2;
            }else{
              height = document.getElementById(plot_div).offsetHeight
            }
            el.style.minHeight = height + "px"
            this.plots[index].Actual_height = height
            let loading_div_id = Plot_id + "_loading"
            let loading_div = `<div  id="`+ loading_div_id +`" style="text-align:center;padding-top:5vh;color:#346168;height:`+height+`px"><div class="spinner-border text-primary" role="status" style="color:#346168 !important"><span class="sr-only">Loading...</span></div></div>`
            
            document.getElementById(Plot_id).insertAdjacentHTML('beforebegin', loading_div)
            var myVar = setInterval(myTimer, 500);
            function myTimer() {
                if(document.getElementById(Plot_id) != null){
                    var isEmpty = document.getElementById(Plot_id).innerHTML === ""
                    if (!isEmpty && document.getElementById(loading_div_id) != null){
                        document.getElementById(loading_div_id).remove()
                        clearInterval(myVar);
                    }
                }
            }
          }
      },
      sortByKey(array, key) {
          return array.sort(function(a, b) {
              var x = a[key]; var y = b[key];
              return ((x < y) ? -1 : ((x > y) ? 1 : 0));
          });
      },
      closemessagemodal(){
        this.$bvModal.hide("chart-message")
      },
      showmodal(plotid){
        this.s_id = plotid
        this.$bvModal.show("chart-message")
      },
      sendToChat(plotid, message){
        if(message != undefined && message != ""){

          var user_string = ""
          if(this.selected_users.length > 0){
            for (let i = 0; i < this.selected_users.length; i++) {
              const element = this.selected_users[i].Email
              user_string += element
              if(i < (this.selected_users.length - 1)){
                user_string += ","
              }
            }
            if(user_string.includes("All Users")){
              user_string = "ALL"
            }
          }else{
            user_string = "ALL"
          }

          axios.post("/plotToChat?apitoken="+this.apitoken+"&id="+plotid+"&message="+message+"&discussion=true"+"&users="+user_string)
          .then(res => {
              this.s_id = ""
              this.chatmessage = ""
              if (res.data !== null && res.data.value !== 1) {
              //  EventBus.$emit('new_chart_message', res.data);
                this.$bvModal.hide("chart-message")
                this.ShowToast("Success", 'Sent to everyone.', "primary") 
              }else{
                this.ShowToast("Error", 'Error while sharing chart. Please try later', "default") 
              }
              this.selected_users = []
          })
        }
      },
      ShowToast(header, body, color){
            this.$bvToast.toast(body, {
                title: header,
                variant: color,
                solid: true,
                toaster: 'b-toaster-top-center'
            })
      },
      closeFullScreen(){
        this.singlePlotShow = false
        this.singleplotdata = {}
        this.$forceUpdate()
      },
      fullscreen(plot){
        //var elmnt = document.getElementById("scroll-to");
        //elmnt.scrollIntoView(); 
        var p = plot
        this.singlePlotShow = true
        this.singleplotdata = p
        let singleplotdata = this.singleplotdata
        let array = singleplotdata.div.split('id="')
        if(array.length > 1){
          let array1 = array[1].split('"')
          let id = array1[0]
          let new_id = id + "__1"
          var re = new RegExp(id, 'g');
          this.singleplotdata.pdiv = singleplotdata.div.replace(re, new_id)
          singleplotdata.KScript = singleplotdata.Script.replace(re, new_id)
          this.singleplotdata.pdiv = this.singleplotdata.pdiv.replace(/<div class="plotly-graph-div" /g, '<div class="plotly-graph-div" style="height:'+600+'px"; ')
           
          let scripts = `<script type="text/javascript">
          setTimeout(function(){
          `
          scripts += singleplotdata.KScript
          scripts = scripts + `}, 400);
          <\/script>`

          console.log(scripts)

          setTimeout(() => {
            postscribe("#single-plot", scripts);
          }, 200);
        }
      }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.bk {
  height: 100% !important;
  width:100% !important;
}
.md-button-content {
  font-size: 1.8vh !important;
}
.btn-info {
        color: #fff !important;
        background-color: #0393f6;
        border-color: #0393f6
}
.bk-canvas{
  height: 100% !important;
  width:100% !important;
}
.md-tabs-indicator {
    bottom: auto !important;
}
.md-tabs-navigation {
    display: block !important;
}
#gist{
  margin:0vh 0px 10vh 0 !important;
}
.dashboard-word{
  font-family: Lato;
  font-size: 1.6vh;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #073c49;
  text-transform: uppercase;
}
.card_d{
    background-color: #e6efee;
    border-radius: 5.5px;
    border: solid 1px #81a1a6;
    margin-bottom:2vh;
    
}
.card-white{
    border-radius: 5.5px;
    border: solid 1px #81a1a6;
    border-radius: 5.5px;
    border: solid 1px #c1c1c1;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,.16);
}
.card-white:hover{
    cursor: pointer;
    -webkit-box-shadow: 0 3px 6px 0 rgba(0,0,0,.16);
    -moz-box-shadow: 0 3px 6px 0 rgba(0,0,0,.16);
    box-shadow: 0 3px 6px 0 rgba(0,0,0,.16);
  }
.tab-title{
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #232323;
  text-transform: capitalize;
  padding-left:2vh;
}
.plot-time{
   font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #346168;
}
.topbox{
  margin-right: 5px;
  padding:10px;
  margin-bottom:5px;
  object-fit: contain;
  border-radius: 6px;
  border: solid 1px #e6efee;
  background-color: #e6efee;
  color:#073c49;
  font-size: 14px;
}
.topbox1{
  margin-right: 5px;
  padding:10px;
  margin-bottom:5px;
  object-fit: contain;
  border-radius: 6px;
  border: solid 1px #4c99a0;
  background-color: #4c99a0;
  color:#fff;
  font-size: 14px;
  font-weight: bold;
}

.empty_state_day {
  color: #073c49;
  text-align: left;
  font-size:14px;
  font-weight: bold;
}
.empty_state_today {
  margin-left: 1vh
}
.empty_state_dots {
  color: #073c49 !important;
  margin-left: -7vh !important
}
.empty_state_content {
  font-family: Lato;
  font-size: 18px;
  text-align: left;
  color: #073c49;
}
.empty_set_project1 {
  border-radius: 5.5px;
  border: solid 1px #81a1a6;
  object-fit: contain;
  opacity: 0.3;
  background-color: #e6efee !important;
  text-align: left;
  margin-bottom: 5vh;
  height: 35vh;
}
.empty_set-card {
  margin-top: 2vh
}
.Rectangle-534 {
  width: 127px;
  height: 16px;
  background-color: #e6efee;
  margin-top:2vh;
  margin-left: 3vh;
  margin-bottom: 3vh;
}
.Rectangle-532 {
  width: 127px;
  height: 10px;
  background-color: #81a1a6;
  margin-bottom: 2vh;
}
.Rectangle-443 {
  width: 7px;
  height: 10px;
  background-color: #81a1a6;
  margin-left: 2vh;
  margin-bottom: 2vh;
}
.Rectangle-531 {
  width: 270px;
  height: 18px;
  background-color: #81a1a6;
  margin-bottom: 2vh
}
.Rectangle-533 {
  width: 270px;
  height: 12px;
  background-color: #81a1a6;
  margin-bottom: 10vh
}
.Rectangle-598 {
  width: 106px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #81a1a6;
}
.Rectangle-601 {
  width: 106px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #81a1a6;
  margin-left: 2vh
}
.empty_set_dashboard {
  margin-top:5vh;
}
.empty_set_dev_content {
  text-align: left;
  font-family: Lato;
}
.empty_set_deviation {
  margin-left: 1vh;
  color:#f16722
}
.empty_set_dist {
  margin-left:4vh;
  margin-right:4vh;
}
.empty_set_img {
  margin-right: 1vh
}
.empty_set_dashboard_card 
{
  border: solid 1px #81a1a6;
  background-color: #e6efee !important;
  margin-bottom: 5vh
}
.card-white {
  object-fit: contain;
}
.empty_set_dashboard_no {
  width: 35px;
  height: 72px;
  font-family: Lato;
  font-size: 59.7px !important;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #e6efee !important;
}
.Rectangle-547 {
  width: 161px;
  height: 12px;
  background-color: #e6efee;
  margin-bottom: 2vh
}
.Rectangle-549 {
  width: 96px;
  height: 12px;
  background-color: #e6efee;
  margin-bottom: 2vh
}
.Path-417 {
  margin-left: 2vh
}
.Group-525 {
  height:45vh;
  object-fit: contain;
}
.Rectangle-536 {
  width: 127px;
  height: 16px;
  background-color: #e6efee;
  margin-bottom: 2vh
}
.Rectangle-535 {
  width: 188px;
  height: 12px;
  background-color: #e6efee;
  margin-left: 2vh;
  margin-bottom: 2vh
}
.Rectangle-537 {
  width: 12px;
  height: 12px;
  background-color: #e6efee;
  margin-left: 2vh;
  margin-bottom: 2vh
}
.Rectangle-5311 {
  width: 270px;
  height: 18px;
  background-color: #e6efee;
  margin-top: 2vh
}
.Path-731 {
  width: 160px;
  height: 12px;
  background-color: #e6efee;
  margin-top: 2vh;
  margin-bottom: 5vh
}
.Rectangle-602 {
  width: 106px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #e6efee;
  margin-top: 10vh
}
.mytask_today {
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  color: #073c49 !important;
  text-align: left;
  margin-left: 5vh
}
.mytask_content {
  font-family: Lato;
  font-size: 18px;
  text-align: left;
  color: #073c49;
  margin-left: 5vh
}
.Path-733 {
  opacity: 0.3;
  border: solid 1px #81a1a6;
  background-color: #e6efee !important;
}
.Rectangle-556 {
  width: 124px;
  height: 13px;
  background-color: #81a1a6 !important;
  margin-top: 2vh;
}
.Rectangle-557 {
  width: 148px;
  height: 13px;
  background-color: #81a1a6 !important;
  margin-top: 2vh;
}
.Rectangle-558 {
  width: 124px;
  height: 13px;
  background-color: #81a1a6 !important;
  margin-top: 1vh;
}
.Rectangle-605 {
  width: 106px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #81a1a6 !important;
  margin-top: 2vh;
}
.Rectangle-562 {
  width: 124px;
  height: 9px;
  background-color: #81a1a6 !important;
  margin-top: 2vh
}
.mytask_upcoming {
  margin-top: 2vh;
  margin-bottom: 5vh
}
.Rectangle-612 {
  width: 240px;
  height: 30px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #e6efee;
  margin-left: 4vh;
  margin-top:2vh;
}
.modal-st{
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16) !important;
    border: solid 1px #81a1a6 !important;
    background-color: #e6efee !important;
}
.modal-content .modal-body{
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16) !important;
  border: solid 1px #81a1a6 !important;
  background-color: #e6efee !important;
}
.respond-btn{
    background-color: #529da3 !important;
    color:white;
}
.cncel_btn {
  background-color: #e6efee;
  border: solid 1px #9cbcbe !important;
  color: #073c49 !important;
  font-size: 15px;
  margin-right:10px;
}
.update_btn {
  background-color: #529da3 !important;
  color: #ffffff !important;
  font-size: 15px;
}
.md-field.md-theme-default label{
  color: rgb(7, 60, 73) !important;
}
.md-focused{
  color: #529da3 !important;
}
.md-field.md-theme-default:before{
  background-color:  rgb(7, 60, 73) !important;
}
.modal-backdrop {
   background-color: red;
}
</style>
